import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const EXPORT_DENIALS_PREDICTORY_SUMMARY = "EXPORT_DENIALS_PREDICTORY_SUMMARY";

export const service = async (data) => {  
  const options: object = {
    url: "/api/DenialsPredictor/ExportDenialsPredictorSummary",
    method: "POST",
    headers: {
      "Content-Type": "application/json",},
    body: JSON.stringify(data),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};


register(EXPORT_DENIALS_PREDICTORY_SUMMARY, service, mock);
